export default __webpack_public_path__ + "static/media/007d5f55b0d6e61040f0d63af0cc8319.svg";